const deviceSizes = {
  mobileWidth: "375px",
  tabletWidth: "768px",
  laptopWidth: "1280px",
  iphoneMiniHeight: "812px",
  iphoneMiniWidth: "375px",
};

const device = {
  iphoneMini: `screen and (max-height: ${deviceSizes.iphoneMiniHeight}) and (max-width: ${deviceSizes.iphoneMiniWidth})`,
  mobile: `screen and (min-width: ${deviceSizes.mobileWidth})`,
  tablet: `screen and (min-width: ${deviceSizes.tabletWidth})`,
  laptop: `screen and (min-width: ${deviceSizes.laptopWidth})`,
};

export const theme = {
  device,
};
